var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTrashRed = function SvgIconTrashRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    stroke: "#E02020",
    strokeWidth: 0.5,
    d: "M9.779 14.813c1.278 0 2.304-1.027 2.354-2.349l.27-8.594h1.26c.186 0 .337-.156.337-.348 0-.19-.151-.347-.336-.347h-3.532v-.783C10.132 1.626 9.527 1 8.787 1H6.23c-.74 0-1.345.626-1.345 1.392v.783H1.336c-.185 0-.336.156-.336.347 0 .192.151.348.336.348h1.262l.269 8.594c.05 1.322 1.076 2.348 2.354 2.348H9.78zM5.558 2.392c0-.383.302-.696.672-.696h2.557c.37 0 .672.313.672.696v.783H5.558v-.783zM3.556 12.429l-.269-8.576h8.46l-.286 8.576c-.034.94-.774 1.688-1.682 1.688H5.238c-.908 0-1.648-.731-1.682-1.688zm4.048-.383c.185 0 .336-.157.336-.348V6.497c0-.192-.151-.348-.336-.348-.185 0-.337.156-.337.348v5.2c0 .192.152.349.337.349zm-1.819 0c.185 0 .337-.157.337-.348V6.497c0-.192-.152-.348-.337-.348-.185 0-.336.156-.336.348v5.2c0 .192.151.349.336.349zm3.637 0c.185 0 .336-.157.336-.348V6.497c0-.192-.151-.348-.336-.348-.185 0-.336.156-.336.348v5.2c0 .192.15.349.336.349z",
    opacity: 0.707
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrashRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash-red.1ebe0df4.svg";
export { ForwardRef as ReactComponent };